export const SHOW_MODAL = 'SHOW_MODAL';
export const SET_SUCCESS_MODAL = 'SET_SUCCESS_MODAL';
export const SET_ERROR_MODAL = 'SET_ERROR_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const modalData = {
    showModal: false,
    isLoading: false,
    isSuccess: false,
    modalTitle: '',
    modalBody: '',
    modalButtonText: '',
};

export const modalReducer = (state, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                ...state,
                showModal: true,
                isLoading: true,
            };
        case SET_SUCCESS_MODAL:
            return {
                ...state,
                showModal: true,
                isSuccess: true,
                modalTitle: action.modalTitle,
                modalBody: action.modalBody,
                modalButtonText: action.modalButtonText,
                isLoading: false,
            };
        case SET_ERROR_MODAL:
            return {
                ...state,
                showModal: true,
                isSuccess: false,
                modalTitle: action.modalTitle,
                modalBody: action.modalBody,
                modalButtonText: action.modalButtonText,
                isLoading: false,
            };
        case CLOSE_MODAL:
            return {
                ...state,
                showModal: false,
            };
        default: {
            return state;
        }
    }
};

export default modalReducer;
